import React, { Fragment, useEffect } from 'react';
import DisableDevtool from 'disable-devtool';
import TextFont from '../assets/letmeshowyou_font.otf';
import { fetchHandleLoginRedirect } from '../functions/authorization';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';

export function Layout (props) {
    fetchHandleLoginRedirect(ApplicationPaths.Login, () => { authService.updateState(null); });
    useEffect(() => {
    DisableDevtool({
            clearLog: 'true',
            disableSelect: 'true',
            disableCopy: 'true',
            disableCut: 'true',
            disablePaste: 'true',
            url: 'about:blank'
          });

      window.oncontextmenu = function(event) {
           event.preventDefault();
           event.stopPropagation();
           return false;
      };
    }, []);

    return (
     <Fragment>
        <style> @font-face {'{'} font-family: 'LetMeShowYou'; src: url({TextFont}) format('opentype'); {'}'} </style>
        {props.children}
     </Fragment>
    );
}
